import React from "react";
import { Bar, Tooltip, CartesianGrid, XAxis, YAxis, ComposedChart, ResponsiveContainer } from "recharts";

function DashboardTrend({ loansStatistics }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <ComposedChart data={loansStatistics} margin={{ top: 16, right: 12, left: -20, bottom: 8 }}>
        <CartesianGrid stroke="#94a3b830" vertical={false} strokeDasharray="3 5" />
        <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 10 }} tickMargin={12} tickFormatter={(name) => String(name).slice(0, 3)} />
        <YAxis axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 10 }} allowDecimals={false} />
        <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 12, color: "#1e293b" }} cursor={{ fill: "#6366f110" }} />
        <Bar dataKey="total" name="Total loans" maxBarSize={28} fill="#413ea0" radius={[5, 5, 0, 0]} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export default DashboardTrend;
